import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

import { EnvironmentService } from '@app/core/services/root/environment.service';

@Injectable()
export class IsTestEnvGuard implements CanActivate {
    constructor(
        private environmentService: EnvironmentService,
        private router: Router
    ) {}

    canActivate(): boolean {
        const environment = this.environmentService.get('environment');
        if (environment === 'prod' || environment === 'production') {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}